<template>
  <div class="sort-icons">
    <v-icon
      :color="sortDir === 'asc' ? 'warning' : undefined"
      @click="$emit('change', 'asc')"
    >
      expand_less
    </v-icon>
    <v-icon
      :color="sortDir === 'desc' ? 'warning' : undefined"
      @click="$emit('change', 'desc')"
    >
      expand_more
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'SortIcons',
  props: {
    sortDir: {
      type: String,
      default: 'asc',
    },
  },
};
</script>

<style>
.sort-icons {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  padding-top: 1px;
  padding-right: 4px;
}
.sort-icons > .v-icon {
  display: block !important;
}
</style>
